(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // Header transparente sobre o Hero, só na Home (ver CSS logo acima,
  // "body.template-index .section-header"). Mede a altura real da Barra de
  // avisos (varia por config/telas) pra o header flutuar exatamente abaixo
  // dela, e troca pra sólido depois de ~5px de scroll, igual à referência.
  if (document.body.classList.contains('template-index')) {
    const zkrHeaderEl = document.querySelector('.section-header');
    const zkrAnnouncementEl = document.querySelector('.utility-bar');

    const setZkrAnnouncementHeight = () => {
      const height = zkrAnnouncementEl ? zkrAnnouncementEl.offsetHeight : 0;
      document.documentElement.style.setProperty('--zkr-announcement-height', `${height}px`);
    };

    const setZkrHeaderScrolled = () => {
      if (!zkrHeaderEl) return;
      zkrHeaderEl.classList.toggle('zkr-header-scrolled', window.scrollY > 5);
    };

    setZkrAnnouncementHeight();
    setZkrHeaderScrolled();

    window.addEventListener('resize', setZkrAnnouncementHeight);
    window.addEventListener('scroll', setZkrHeaderScrolled, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zakra-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ZakraHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.zakra-hero-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.zakra-hero-slideshow__dot'));
      this.prevBtn = this.querySelector('.zakra-hero-slideshow__arrow--prev');
      this.nextBtn = this.querySelector('.zakra-hero-slideshow__arrow--next');
      this.current = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      if (this.autoplay && this.slides.length > 1 && !this.reducedMotion) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.go(this.current + 1), this.speed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }

    go(index) {
      const total = this.slides.length;
      if (total === 0) return;
      this.current = (index + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('zakra-hero-slideshow', ZakraHeroSlideshow);

  } catch(e) { console.error(e); }
})();
})();
